var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_899_2596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1C8.7615 1 11 3.2385 11 6C11 8.7615 8.7615 11 6 11C3.2385 11 1 8.7615 1 6C1 3.2385 3.2385 1 6 1ZM6 2C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6C2 7.06087 2.42143 8.07828 3.17157 8.82843C3.92172 9.57857 4.93913 10 6 10C7.06087 10 8.07828 9.57857 8.82843 8.82843C9.57857 8.07828 10 7.06087 10 6C10 4.93913 9.57857 3.92172 8.82843 3.17157C8.07828 2.42143 7.06087 2 6 2ZM6 3.5C6.52629 3.5002 7.0391 3.66649 7.46536 3.97517C7.89162 4.28385 8.2096 4.71919 8.37398 5.21915C8.53836 5.71911 8.54077 6.2582 8.38086 6.75961C8.22094 7.26102 7.90687 7.69918 7.48338 8.01165C7.0599 8.32413 6.54859 8.49499 6.02232 8.49989C5.49605 8.50479 4.98166 8.34348 4.55243 8.03894C4.1232 7.7344 3.80102 7.30217 3.6318 6.80382C3.46258 6.30548 3.45495 5.76644 3.61 5.2635C3.72696 5.52486 3.93014 5.73811 4.18553 5.86758C4.44092 5.99705 4.73303 6.03488 5.01297 5.97473C5.29292 5.91458 5.54371 5.76011 5.72339 5.53717C5.90306 5.31422 6.00071 5.03633 6 4.75C6.00007 4.50923 5.9306 4.27357 5.79994 4.07134C5.66929 3.8691 5.48301 3.70891 5.2635 3.61C5.4965 3.5385 5.7435 3.5 6 3.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_899_2596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.28d38304b2d085846d0f9713e59e3ee8.svg";
export { ForwardRef as ReactComponent };